
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiairportinnovacrystacar() {



    const cardData =
    {
        keyword: 'Pune to Mumbai Airport Innova Crysta Car Rental',
        heading: 'Meghana Cab : Pune to Mumbai Airport Innova Crysta Car Rental',
        headingDescription: 'Meghana Cab offers Pune to Mumbai Airport Innova Crysta Car Rental, providing a premium and hassle-free airport transfer experience for individuals, families, and corporate travelers. Our Innova Crysta vehicles are designed for comfort with plush leather seating, ample legroom, air-conditioning, and generous luggage space—making it the perfect choice for long-distance airport journeys.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924, the Gateway of India is Mumbai’s most iconic landmark, symbolizing the city’s colonial past and architectural grandeur. Overlooking the Arabian Sea, it was originally constructed to welcome King George V and Queen Mary. Surrounded by street vendors, photographers, and ferry points to Elephanta Caves, it's the ideal starting point for tourists. At night, the monument glows under warm lights, offering a picturesque backdrop for a waterfront stroll."
  },
  {
    "title": "Marine Drive & Chowpatty Beach",
    "description": "Marine Drive, also called the 'Queen’s Necklace', is a 3.6-kilometer crescent-shaped boulevard along the Arabian Sea. Lined with palm trees and art deco buildings, it’s popular for sunset views, sea breeze walks, and jogging. Chowpatty Beach at the northern end serves as a food paradise with bhel puri, pav bhaji, and kulfi stalls, especially lively during Ganesh Visarjan and cultural festivals."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site, CST (formerly Victoria Terminus) is one of the world’s most beautiful railway stations. Built in 1887, it showcases Victorian Gothic architecture blended with Indian influences. With intricate carvings, turrets, and stained glass windows, CST is both a functional transit hub and an architectural marvel. It's a must-visit for history buffs and photography lovers."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, about an hour’s ferry ride from the Gateway of India, these UNESCO-listed caves date back to the 5th–8th centuries. The main cave features a massive Trimurti sculpture of Lord Shiva. The caves reflect ancient Indian rock-cut art and offer a peaceful retreat from Mumbai’s bustle. The island also features nature trails and panoramic sea views."
  },
  {
    "title": "Juhu Beach",
    "description": "One of Mumbai’s most famous beaches, Juhu is known for its lively ambiance, local street food, and proximity to celebrity homes. Visitors flock here for sunset views, pony rides, or to enjoy snacks like sev puri and falooda. During festivals, the beach transforms into a spiritual hub for idol immersions. It’s also popular among joggers, photographers, and families looking for open space and sea breeze."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most sacred temples. Built in 1801, it is visited by lakhs of devotees, including celebrities and politicians. The temple’s gold-plated dome and black stone idol are renowned for granting wishes. Tuesdays are particularly crowded, and the temple’s well-managed premises offer a calm, spiritual atmosphere amidst the urban buzz."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in the 15th century, Haji Ali Dargah is a beautiful Indo-Islamic shrine located on an islet off the coast of Worli. Dedicated to the Sufi saint Haji Ali, the dargah is connected to the mainland by a narrow causeway that becomes submerged during high tide. The white domes and tranquil prayers offer a deeply spiritual experience, attracting people from all faiths."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "One of the few national parks within a city, Sanjay Gandhi National Park is a 100 sq. km green oasis in North Mumbai. It features leopards, deer, and 250+ bird species. Inside, the Kanheri Caves offer over 100 Buddhist rock-cut caves dating back to the 1st century BCE. Ideal for hiking, wildlife photography, and heritage exploration, it's a nature lover’s haven within city limits."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a modern engineering marvel that connects South Mumbai with the western suburbs. Stretching over 5.6 km, it reduces travel time and offers breathtaking views of the coastline, especially at sunrise or during night drives. It's a symbol of Mumbai’s urban transformation and a favorite backdrop for cinematic shoots and scenic drives."
  },
  {
    "title": "Colaba Causeway",
    "description": "Located near the Gateway of India, Colaba Causeway is a vibrant shopping street filled with antiques, jewelry, clothes, books, and street-side eateries. Famous cafés like Leopold and Café Mondegar add charm and nostalgia. This bustling lane is perfect for souvenir shopping, café hopping, or soaking in Mumbai’s cosmopolitan vibe."
  }
],

  "services": [
    {
      "name": "Pune to Mumbai Airport Innova Crysta Rental",
      "description": "Book a reliable Innova Crysta rental from Pune to Mumbai Airport for a stress-free airport transfer. Our spacious, well-maintained SUVs offer top-notch comfort, ample luggage space, and timely service, ensuring you reach the airport on time, every time."
    },
    {
      "name": "One Way Innova Crysta Pune Mumbai Airport",
      "description": "Planning a one-way trip from Pune to Mumbai Airport? Our one-way Innova Crysta cab service offers convenience, cost-efficiency, and luxury, making your intercity journey smooth and comfortable without the burden of return fare."
    },
    {
      "name": "Round Trip Innova Crysta Pune Mumbai Airport",
      "description": "Need to return the same day? Our round-trip Innova Crysta cab service between Pune and Mumbai Airport is ideal for business travelers and families. Enjoy flexible scheduling, professional chauffeurs, and a worry-free ride both ways."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Mumbai Airport",
      "description": "Travel in complete comfort with our fully air-conditioned Innova Crysta taxis from Pune to Mumbai Airport. Beat the traffic and the weather with our clean, cool, and spacious vehicles that ensure a relaxing ride across cities."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Mumbai Airport",
      "description": "Our chauffeur-driven Innova Crysta service offers the perfect balance of comfort and professionalism. Our drivers are punctual, courteous, and trained for long-distance travel, making your Pune to Mumbai Airport journey safe and relaxing."
    },
    {
      "name": "Online Booking Innova Crysta Cab Pune Mumbai Airport",
      "description": "Book your Pune to Mumbai Airport Innova Crysta cab online in just a few clicks. Our seamless digital booking platform offers instant confirmation, multiple payment options, and complete trip customization for your convenience."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Mumbai Airport",
      "description": "Enjoy privacy and peace of mind with our private Innova Crysta taxi service from Pune to Mumbai Airport. Ideal for executives, families, or couples, this service ensures you travel comfortably with no ride-sharing and personalized attention."
    }
  ],
  "tableData": [
    ["Pune to Mumbai Airport Innova Crysta Rental", "One Way Innova Crysta Pune Mumbai Airport"],
    ["Round Trip Innova Crysta Pune Mumbai Airport", "AC Innova Crysta Taxi Pune Mumbai Airport"],
    ["Chauffeur Driven Innova Crysta Pune Mumbai Airport", "Online Booking Innova Crysta Cab Pune Mumbai Airport"],
    ["Private Innova Crysta Taxi Pune Mumbai Airport", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Rental for Pune to Mumbai Airport",
        "WhyChoosedescription": "Enjoy a comfortable and timely ride from Pune to Mumbai International or Domestic Airport with our Innova Crysta car rental service. Designed for comfort, reliability, and convenience, it's ideal for business travelers, families, or groups needing smooth airport transfers."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Airport Travel",
        "WhyChoosedescription": "Innova Crysta offers ample space for up to 6–7 passengers and luggage, making it the perfect vehicle for airport transfers. Reclining seats, dual AC, and smooth suspension ensure a stress-free ride even during long-distance travel or traffic delays."
    },
    {
        "WhyChooseheading": "Professional and Airport-Savvy Chauffeurs",
        "WhyChoosedescription": "Our experienced drivers understand the importance of on-time airport drop-offs and pickups. They are punctual, courteous, and familiar with the fastest and most efficient Pune–Mumbai routes to avoid delays, ensuring you reach the airport well in time."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Maintained Fleet",
        "WhyChoosedescription": "All Innova Crysta vehicles are sanitized before every ride and undergo regular maintenance checks. Travel in a clean, fresh environment with full confidence in vehicle safety and hygiene standards."
    },
    {
        "WhyChooseheading": "Flexible Pickup Times and Doorstep Service",
        "WhyChoosedescription": "Choose your pickup time and location across Pune, including Hinjewadi, Baner, Kothrud, Viman Nagar, and more. We ensure convenient doorstep pickup and smooth travel to Mumbai Airport, 24/7."
    },
    {
        "WhyChooseheading": "Transparent and All-Inclusive Pricing",
        "WhyChoosedescription": "Our pricing covers fuel, tolls, driver charges, and taxes—no hidden costs. Get reliable airport transfers at fair and transparent rates, with instant booking confirmation and billing clarity."
    },
    {
        "WhyChooseheading": "Ideal for Corporate, Family, and Group Transfers",
        "WhyChoosedescription": "Whether you're a business executive heading for a flight, a family catching a holiday flight, or a group traveling together, our Innova Crysta is the perfect blend of space, style, and reliability."
    },
    {
        "WhyChooseheading": "24/7 Availability and Booking Support",
        "WhyChoosedescription": "Our booking system is open 24/7, with customer service available to assist at any time. Book last-minute or schedule in advance—our team ensures a seamless and punctual airport travel experience."
    }
]





















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta car rental from Pune to Mumbai Airport?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for quick and easy booking."
    },
    {
        question: "What is the approximate travel time from Pune to Mumbai Airport by Innova Crysta?",
        answer: "The journey usually takes around 3 to 4 hours, depending on traffic conditions."
    },
    {
        question: "Is the Innova Crysta comfortable for airport transfers?",
        answer: "Yes, the Innova Crysta offers spacious seating and a smooth ride, ideal for airport travel with luggage."
    },
    {
        question: "Can I book a one-way or round-trip rental for Pune to Mumbai Airport?",
        answer: "Yes, both one-way and round-trip bookings are available."
    },
    {
        question: "How many passengers can the Innova Crysta accommodate?",
        answer: "The Innova Crysta comfortably seats 6 to 7 passengers with ample space for luggage."
    },
    {
        question: "Are the vehicles sanitized before every trip?",
        answer: "Absolutely, all vehicles are cleaned and sanitized prior to each journey for your safety."
    },
    {
        question: "Do the drivers have experience with airport transfers?",
        answer: "Yes, our drivers are well-experienced in handling airport transfers to ensure timely pickups and drops."
    },
    {
        question: "What is included in the rental fare?",
        answer: "The fare includes fuel, tolls, and driver charges. Additional waiting or parking charges may apply."
    },
    {
        question: "Is the Innova Crysta rental service available 24/7 for airport transfers?",
        answer: "Yes, Meghana Cab offers round-the-clock service for airport transfers."
    },
    {
        question: "What payment methods do you accept for this service?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Kunal Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for Pune to Mumbai Airport transfer. The service was punctual and the ride very comfortable.”',
    },
    {
        name: 'Ms. Nidhi Rao',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent car rental experience with Meghana Cab. The Innova Crysta was spacious and perfect for airport travel.”',
    },
];





















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const puneToMumbaiAirportInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Mumbai Airport Innova Crysta Car Rental",
  "description": "Chauffeur-driven Innova Crysta car rental service from Pune to Mumbai Airport. Offering one way and round trip options with AC comfort and private taxi booking online.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Airport Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-airport-innova-crysta-rental"
  }
};









    return (
        <div>

<Helmet>
  <title>Pune to Mumbai Airport Innova Crysta Car Rental | Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta car rental from Pune to Mumbai Airport. One way and round trip options available with private and AC taxi service."
  />
  <meta
    name="keywords"
    content="Pune to Mumbai Airport Innova Crysta Rental, One Way Innova Crysta Pune Mumbai Airport, Round Trip Innova Crysta Pune Mumbai Airport, AC Innova Crysta Taxi Pune Mumbai Airport, Chauffeur Driven Innova Crysta Pune Mumbai Airport, Online Booking Innova Crysta Cab Pune Mumbai Airport, Private Innova Crysta Taxi Pune Mumbai Airport"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToMumbaiAirportInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/31.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiairportinnovacrystacar;